import React from 'react';
import classes from './OpenSource.module.css';
import Contribution from './Contribution';
import { OpenSourceData } from '../../../Assets/Data/OpenSourceData';
import Header from '../../UI/Header/Header';

const OpenSource = () => {
  return (
    <>
      <div className={classes.opensource_section} id="projects">
        <div className={classes.heading}>
          <Header header="OPEN SOURCE" styles={classes.heading} />
        </div>
        <div className={classes.contribution}>
          {OpenSourceData.map((project, index) => {
            return <Contribution project={project} key={index} />;
          })}
        </div>
      </div>
    </>
  );
};

export default OpenSource;
